/* Shop by category rail — a continuous marquee.

   The track scrolls at a constant pixels-per-second via rAF rather than
   stepping card to card, so there is no snap-to jerk and no jump back to the
   start: the card list is duplicated once, and when the first copy has fully
   passed we subtract its width, which lands on a visually identical frame.

   Pauses on hover, on keyboard focus and when the tab is hidden. Never runs
   under prefers-reduced-motion or when every card already fits — the arrows
   and native scrolling still work in every case. */
(function () {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRail(rail) {
    if (!rail || rail.dataset.railReady) return;
    rail.dataset.railReady = '1';
    var track = rail.querySelector('[data-catrail-track]');
    var prev = rail.querySelector('[data-catrail-prev]');
    var next = rail.querySelector('[data-catrail-next]');
    if (!track) return;

    var originals = [].slice.call(track.querySelectorAll('[data-catrail-item]'));
    if (originals.length < 2) return;

    var speed = parseFloat(rail.getAttribute('data-speed')) || 55; // px per second
    var wantsAuto = rail.getAttribute('data-autoplay') === 'true' && !reduceMotion;
    var paused = false;
    var cloned = false;
    var raf = null;
    var last = 0;

    function setWidth() {
      // width of one full set of originals, including the gap that follows it
      var first = originals[0].getBoundingClientRect();
      var second = originals[1].getBoundingClientRect();
      var stride = second.left - first.left;
      return stride * originals.length;
    }
    var setW = 0;

    function cloneOnce() {
      if (cloned) return;
      originals.forEach(function (el) {
        var copy = el.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('tabindex', '-1');
        copy.removeAttribute('data-catrail-item');
        copy.setAttribute('data-catrail-clone', '');
        // a cloned lazy <img> may never have fetched; make sure it does
        var img = copy.querySelector('img');
        if (img) { img.loading = 'eager'; img.setAttribute('src', img.getAttribute('src')); }
        track.appendChild(copy);
      });
      cloned = true;
    }

    function overflows() { return track.scrollWidth - track.clientWidth > 4; }

    function tick(now) {
      if (!last) last = now;
      var dt = (now - last) / 1000;
      last = now;
      if (!paused && !document.hidden && dt > 0 && dt < 0.5) {
        track.scrollLeft += speed * dt;
        // one full set has passed — rewind by exactly that, mid-frame and invisible
        if (setW > 0 && track.scrollLeft >= setW) track.scrollLeft -= setW;
      }
      raf = requestAnimationFrame(tick);
    }

    function start() {
      if (!wantsAuto || raf || !overflows()) return;
      cloneOnce();
      setW = setWidth();
      // free scrolling while the marquee runs; snap would fight it
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      last = 0;
      raf = requestAnimationFrame(tick);
    }

    function stop() {
      if (raf) { cancelAnimationFrame(raf); raf = null; }
    }

    function stepBy(dir) {
      var first = originals[0].getBoundingClientRect();
      var second = originals[1].getBoundingClientRect();
      var stride = Math.round(second.left - first.left);
      var target = track.scrollLeft + stride * dir;
      if (setW > 0) {
        if (target < 0) target += setW;
        if (target >= setW) target -= setW;
      } else {
        var max = track.scrollWidth - track.clientWidth;
        if (target < 0) target = max;
        if (target > max) target = 0;
      }
      track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { stepBy(-1); });
    if (next) next.addEventListener('click', function () { stepBy(1); });

    ['mouseenter', 'focusin', 'pointerdown'].forEach(function (evt) {
      rail.addEventListener(evt, function () { paused = true; }, { passive: true });
    });
    ['mouseleave', 'focusout'].forEach(function (evt) {
      rail.addEventListener(evt, function () {
        if (!rail.contains(document.activeElement)) paused = false;
      });
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { paused = true; } else { paused = false; last = 0; }
    });

    function sync() {
      var show = overflows();
      if (prev) prev.hidden = !show;
      if (next) next.hidden = !show;
      if (!show) { stop(); return; }
      if (cloned) setW = setWidth();
      start();
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sync, 150);
    });

    // wait for images so the measured set width is final
    if (document.readyState === 'complete') sync();
    else window.addEventListener('load', sync);
  }

  function initAll() { document.querySelectorAll('[data-catrail]').forEach(initRail); }

  // rails whose cards arrive later (New in-store fetches them) call this
  window.LumRailInit = initRail;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
